import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/CorporateGovernancePage.css";

const CorporateGovernancePage = () => {
  const policies = [
    {
      title: "Policy on the matters relating to the Board of Directors",
      file: "Policy_1.pdf",
    },
    { title: "Policy on Board Committees", file: "Policy_2.pdf" },
    {
      title: "Policy on Corporate Governance, Nominations and Re-election",
      file: "Policy_3.pdf",
    },
    { title: "Policy on Remuneration", file: "Policy_4.pdf" },
    {
      title:
        "Policy on Internal Code of Business Conduct and Ethics for all Directors and Employees, including policies on trading in the Entity's listed Securities",
      file: "Policy_5.pdf",
    },
    {
      title: "Policy of Risk Management and Internal Controls",
      file: "Policy_6.pdf",
    },
    {
      title: "Policy on Relations with Shareholders and Investors",
      file: "Policy_7.pdf",
    },
    {
      title: "Policy on Environment, Social and Governance Sustainability",
      file: "Policy_8.pdf",
    },
    {
      title:
        "Policy on Control and Management of Company Assets and Shareholder Investments",
      file: "Policy_9.pdf",
    },
    { title: "Policy on Corporate Disclosures", file: "Policy_10.pdf" },
    { title: "Policy on Whistleblowing", file: "Policy_11.pdf" },
    { title: "Policy on Anti-Bribery and Corruption", file: "Policy_12.pdf" },
  ];

  return (
    <>
      <Header />

      <section
        className="corporate-governance-banner"
        style={{
          backgroundImage: "url('/wp-content/uploads/2024/10/corp-gov.jpg')",
        }}
      ></section>

      <div className="corporate-governance-wrapper">
        <div className="center-container">
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Corporate Governance</span>
          </div>

          <h1 className="page-title" data-aos="fade-right">
            Corporate Governance
          </h1>

          <div className="policies-list">
            <ol>
              {policies.map((policy, index) => (
                <li key={index} data-aos="fade-right" data-aos-delay={index * 50}>
                  <a
                    href={`/wp-content/uploads/2024/10/${policy.file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {policy.title}
                  </a>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default CorporateGovernancePage;
